import { MESApiService, spParameter } from "@dexteel/mesf-core";

export const getHeats = async () => {
	const apiService = new MESApiService();
	return await apiService.callV2("[MS].[GetHeats]", []);
};
export const getHeat = async (HeatId: number) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "HeatId", value: HeatId });
	return await apiService.callV2("[SWV].[GetHeat]", parameters);
};
export const getLastHeat = async () => {
	const apiService = new MESApiService();
	return await apiService.callV2("[MS].[GetLastHeat]", []);
};
export const searchHeatNames = async ({
	searchText = "",
	IncludeIsExternal = null,
}: {
	searchText?: string;
	heatId?: number | null;
	IncludeIsExternal?: boolean | null;
}) => {
	const sqlParameters = [];
	sqlParameters.push({ name: "@SearchText", value: searchText.trim() });
	sqlParameters.push({
		name: "@ShowExternalHeats",
		value: IncludeIsExternal,
	});
	const apiService = new MESApiService();

	return await apiService.callV2("[MS].[SearchHeatNames]", sqlParameters);
};
